import React from 'react';

import cn from 'classnames';

import { Table } from '@shared/components/bootstrap';
import { Currency } from '@shared/components/helpers';

import { SelectedCheck } from '@admin/components/orders/show/selected_check';
import { Maybe, PlanKindEnum, Pricing, SubscriptionFragment } from '@admin/schema';

export const StoragePricingTable: React.FC<{
  isCustom: boolean;
  selectedSubscription: Maybe<SubscriptionFragment>;
  storageLadderPricings?: Maybe<Pricing[]>;
}> = ({ isCustom, selectedSubscription, storageLadderPricings }) => {
  let selectedCuft = 0;
  let selectedRate = 0;
  if (selectedSubscription) {
    selectedCuft = selectedSubscription.customDimension?.cuft ?? selectedSubscription.pricing.plan.cuft;
    selectedRate = (isCustom ? selectedSubscription.quantity : selectedSubscription.pricing.amount) / selectedCuft;
  }

  const customPrice = (pricing: Pricing) => Math.round(selectedRate * pricing.plan.cuft);

  const dimensionalPlans = storageLadderPricings?.filter((pricing) => pricing.plan.kind !== PlanKindEnum.Custom);

  if (!dimensionalPlans) {
    return <p>No attached storage ladder or pricing set.</p>;
  }

  return (
    <Table striped>
      <thead>
        <tr>
          <th className="text-left col-sm-2">Plan</th>
          <th className="text-left col-sm-2">Price</th>
        </tr>
      </thead>
      <tbody>
        {dimensionalPlans.map((pricing, i) => {
          const selected = !!selectedSubscription && pricing.plan.cuft === selectedCuft;
          return (
            <tr key={i} className={cn({ info: selected })}>
              <td className="text-left col-sm-2">
                {pricing.plan.name}
                <SelectedCheck selected={selected} />
              </td>
              <td className="text-left col-sm-2">
                <Currency value={isCustom ? customPrice(pricing) : pricing.amount} currency={pricing.currency} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
